export enum AccountRole {
    Superadmin = 0,
    Admin = 5,
    Company = 10,
    Agent = 20
}

export function translateAccountRole(role: AccountRole): string {
    switch (role) {
        case AccountRole.Superadmin:
            return 'Superadmin';
        case AccountRole.Admin:
            return 'Admin';
        case AccountRole.Company:
            return 'Company';
        case AccountRole.Agent:
            return 'Agent';
        default:
            return 'role';
    }
}
